import { gql } from 'graphql-tag';

export const updateContactListSchedule = gql`
  mutation updateContactListSchedule($input: ContactListScheduleInput) {
    updateContactListSchedule(input: $input) {
      id
      isPrimary
      startTime
      endTime
      timezone
    }
  }
`;
